import React, { useContext } from "react";
import { Col, Row, Typography } from "antd";

import { PHResidentSection_fields } from "./fields-object/fields-object";
import { OvernighGuestContext } from "./context-view";
import { overnightGuestInitalValues as initialValues } from "./initialvalues/initialValues";

const { Paragraph } = Typography;

const Index = () => {
  let { pageData } = useContext(OvernighGuestContext);
  const data = pageData?.data || initialValues;

  return (
    <>
      <Row gutter={10}>
        <Col span={14} />
        <Col span={5}>
          <Paragraph level={4}> Male </Paragraph>
        </Col>
        <Col span={5}>
          <Paragraph level={4}> Female </Paragraph>
        </Col>
      </Row>

      {PHResidentSection_fields.map((field, index) => (
        <Row
          key={index}
          gutter={10}
          className={"row-darken"}
          justify="space-between"
          align="center"
        >
          <Col span={14}>{field.label}</Col>
          {field.types.map((type) => (
            <Col span={5}>{data[field.name][type]}</Col>
          ))}
        </Row>
      ))}
      <Row
        gutter={10}
        className={"row-darken"}
        justify="space-between"
        align="center"
      >
        <Col span={14}>Total Philippine Residents</Col>

        <Col span={5}>
          {data["filipinoNationality"]["male"] +
            data["filipinoForeign"]["male"]}
        </Col>

        <Col span={5}>
          {data["filipinoNationality"]["female"] +
            data["filipinoForeign"]["female"]}
        </Col>
      </Row>
    </>
  );
};

export default Index;
